<div class="loyalty-messages" *ngIf="(messages$ | async)?.data?.length > 0">
    <div class="loyalty-messages__wrapper wrapper">

        <shared-slider-side-counter [inverted]="inverted" [dots]="dots" class="loyalty-messages__slider">
            <shared-tile-for-loyalty-message class="loyalty-messages__msg" [inverted]="inverted" [message]="message"
                *ngFor="let message of (messages$ | async)?.data; trackBy: trackBy">
            </shared-tile-for-loyalty-message>
        </shared-slider-side-counter>

    </div>
</div>